import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { isRouteWithoutHeader } from 'src/config/routes';
import { useAuth } from 'src/hooks/auth';
import { useFetch } from 'src/hooks/fetch';
import {
  getAccountFetchStatus,
  getAccountData,
  selectUserAccountType,
} from 'src/store/account';

import { NavigationHeader } from './NavigationHeaderExperiment';

export const NavigationHeaderContainer = () => {
  const location = useLocation();
  const { getAuthToken } = useAuth();
  const authToken = getAuthToken();

  if (isRouteWithoutHeader(location.pathname)) {
    return null;
  }

  if (authToken === undefined) {
    return <NavigationHeader variant="logged-out" />;
  }

  // We have to call .NET to determine what type the user is
  return <NavigationHeaderLoggedIn />;
};

// This is a separate component so we can use "useFetch(getAccountFetchStatus, getAccountData);".
// This API call is dependent on our "getAuthToken()" resolving as the generated
// token is passed as an auth header
const NavigationHeaderLoggedIn = () => {
  const getAccountDataResult = useFetch(getAccountFetchStatus, getAccountData);
  const userAccountType = useSelector(selectUserAccountType);

  if (!getAccountDataResult.hasLoaded) {
    return <NavigationHeader variant="logged-in-loading" />;
  }

  const variant =
    userAccountType === 'Buyer' ? 'logged-in-buyer' : 'logged-in-client';
  return <NavigationHeader variant={variant} />;
};
